export default __webpack_public_path__ + "static/media/pictureIcon.68c1dec1.png";